import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "anokina_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Что-то пошло не так";
  const humanize = (msg) => {
    const s = String(msg || "").toLowerCase();
    if (s.includes("field required") || s.includes("value is required")) return "Заполните обязательное поле";
    if (s.includes("string_too_short") || s.includes("at least 1 character")) return "Поле не должно быть пустым";
    if (s.includes("string_too_long")) return "Слишком длинное значение";
    if (s.includes("value error")) return "Некорректное значение";
    return String(msg);
  };
  if (typeof detail === "string") return humanize(detail);
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? humanize(e.msg) : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return humanize(detail.msg);
  return String(detail);
}
